import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logoIcon from '../assets/icon1-no-bg.png';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Hide navbar on admin pages
  const isAdminPage = location.pathname.startsWith('/admin');
  if (isAdminPage) return null;

  const linkClass = "font-body-md text-[18px] md:text-body-md text-on-surface-variant hover:text-primary transition-colors hover:opacity-80 transition-opacity duration-200";

  const NavLinks = () => (
    <>
      <Link className={linkClass} to="/" onClick={() => {
        setIsMobileMenuOpen(false);
        if (location.pathname === '/') window.scrollTo({ top: 0, behavior: 'smooth' });
      }}>Home</Link>
      {location.pathname === '/' ? (
        <>
          <a className={linkClass} href="#how-it-works" onClick={() => setIsMobileMenuOpen(false)}>How it Works</a>
          <a className={linkClass} href="#services" onClick={() => setIsMobileMenuOpen(false)}>Services</a>
        </>
      ) : (
        <>
          <Link className={linkClass} to="/#how-it-works" onClick={() => setIsMobileMenuOpen(false)}>How it Works</Link>
          <Link className={linkClass} to="/#services" onClick={() => setIsMobileMenuOpen(false)}>Services</Link>
        </>
      )}
      <Link className={linkClass} to="/contact" onClick={() => setIsMobileMenuOpen(false)}>Contact Us</Link>
    </>
  );

  return (
    <>
    <header className={`fixed top-0 left-0 right-0 w-full z-50 transition-all duration-300 ${isScrolled ? "bg-surface/70 backdrop-blur-2xl border-b border-white/20 shadow-sm" : "bg-surface border-transparent"}`} id="main-header">
      <div className="flex justify-between items-center px-6 md:px-12 py-4 max-w-[1400px] mx-auto">
        <Link to="/" onClick={() => {
          if (location.pathname === '/') window.scrollTo({ top: 0, behavior: 'smooth' });
        }} className="flex items-center gap-2 font-display-lg-mobile md:font-display-lg text-[24px] md:text-[32px] text-primary dark:text-inverse-primary tracking-tight font-bold scale-95 active:scale-90 transition-transform z-[60]">
          <img src={logoIcon} alt="TankCare Icon" className="w-8 h-8 md:w-10 md:h-10 object-contain" />
          TankCare
        </Link>
        
        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-8 items-center">
          <NavLinks />
        </nav>
        
        {/* Desktop Actions */}
        <div className="hidden md:flex items-center gap-4">
          <Link to="/booking" className="bg-primary text-on-primary px-6 py-2 rounded-lg font-body-md text-body-md hover:bg-on-primary-fixed-variant transition-colors shadow-sm scale-95 active:scale-90 transition-transform">Book Now</Link>
        </div>

        {/* Mobile Hamburger Toggle */}
        <button className={`md:hidden text-primary p-2 z-[60] ${isMobileMenuOpen ? 'opacity-0 pointer-events-none' : ''}`} onClick={() => setIsMobileMenuOpen(true)}>
          <span className="material-symbols-outlined text-3xl">menu</span>
        </button>
      </div>
    </header>

    {/* Mobile Slide-out Drawer */}
    <div className={`fixed inset-0 z-[65] bg-surface/95 backdrop-blur-3xl transition-transform duration-300 md:hidden flex flex-col ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
      <div className="flex justify-end p-6 pt-8">
        <button type="button" className="text-on-surface p-4 relative z-[70] cursor-pointer touch-manipulation" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsMobileMenuOpen(false);
        }}>
          <span className="material-symbols-outlined text-4xl">close</span>
        </button>
      </div>
      <div className="flex flex-col items-center justify-center h-full gap-8 p-8 -mt-16">
        <div className="flex flex-col items-center gap-6">
          <NavLinks />
        </div>
        <div className="flex flex-col items-center gap-6 mt-8 w-full max-w-xs border-t border-outline/20 pt-8">
          <Link to="/booking" className="bg-primary text-on-primary w-full text-center px-6 py-3 rounded-lg font-body-md text-[18px] hover:bg-opacity-90 transition-colors shadow-sm mt-4" onClick={() => setIsMobileMenuOpen(false)}>Book Now</Link>
        </div>
      </div>
    </div>
    </>
  );
};

export default Navbar;